import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { Constants, ItsrApiService, MixpanelService } from '../_services';
import { MixpanelTrackedFormComponent, matchPasswordValidator } from '../global';

@Component({
  templateUrl: 'forgotpasswordsubmit.component.html'
})
export class ForgotpasswordSubmitComponent extends MixpanelTrackedFormComponent implements OnInit, OnDestroy {
  private readonly valueChangesSubscription: Subscription;
  data: any = null;
  securityCode: string = '';
  showLoadingIcon: boolean = false;
  formSuccess: boolean | null = null;
  displayError: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private itsrApiService: ItsrApiService,
    formBuilder: FormBuilder,
    mixpanelService: MixpanelService
  ) {
    super(
      formBuilder.group({
        userName: [null, Validators.compose([Validators.required])],
        newPassword: [null, Validators.compose([
          Validators.required,
          Validators.minLength(8), Validators.maxLength(12),
          Validators.pattern(Constants.RegEx.Password)
        ])],
        newPasswordConfirm: [null, Validators.compose([Validators.required])],
      }),
      mixpanelService
    );

    this.form.get('newPasswordConfirm').setValidators([
      Validators.required,
      matchPasswordValidator(this.form.get('newPassword'))
    ]);

    this.valueChangesSubscription = this.form.get('newPassword').valueChanges.subscribe((): void => {
      this.form.get('newPasswordConfirm').updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    this.securityCode = this.route.snapshot.queryParams['token'];
    this.data = this.route.snapshot.data;
    this.mixpanelService.trackPageView(this.data.content.windowTitle);
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
  }

  submit(event: Event): void {
    event.preventDefault();

    if (!this.isFormGroupValid()) {
      this.markAllFormFieldsTouched();
      this.setFocusOnFirstInvalidField();
      return;
    }

    this.showLoadingIcon = true;
    const { userName, newPassword, newPasswordConfirm } = this.form.value;
    const subscription = this.itsrApiService
      .postForgotPassword(this.securityCode, userName, newPassword, newPasswordConfirm)
      .subscribe(
        (response) => {
          if (ItsrApiService.isErrorResponse(response)) {
            this.formSuccess = false;
            this.displayError = response.Errors[0].Message;
            return;
          }

          this.router.navigate(['/login']);
        },
        undefined, // error handler
        (): void => {
          this.showLoadingIcon = false;
          subscription.unsubscribe();
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/forgotpasswordsubmit.component.ts